import {useEffect, useMemo, useState} from "react";
import getData from "../../../api/axiosInstance";
import {Link} from "react-router-dom";
import {ArrowLongRightIcon, ArrowLongUpIcon} from "@heroicons/react/24/outline";

export default function ProfitMarginCard() {
    const [dataValue, setDataValue] = useState(0);

    const token = localStorage.getItem("token");

    const headers = useMemo(() => {
        return {
            'Authorization': `Bearer ${token}`
        };
    }, [token]);

    useEffect(() => {
        getData(
            '/purchased_items/average_margin_percent',
            headers,
            setDataValue,
            'Error fetching average profit margin'
        );
    }, [headers]);

    // Ovdje se pretpostavlja da je format za procenat
    const valueFormatter = (value) => `${value.toFixed(2)}%`;

    // Dobijamo procenat za profitnu marginu
    const profitMargin = valueFormatter(dataValue);

    return (
        <li className="py-1.5">
            <Link onClick={() => sessionStorage.setItem('scrollPosition', window.scrollY.toString())}>
                <div className="flex items-center space-x-4 text-left p-0 focus:bg-green-50 dark:focus:bg-cyan-900 hover:bg-green-50 dark:hover:bg-cyan-900">
                    <div className="flex-1 min-w-0">
                        <p className="text-md font-medium text-gray-900 truncate dark:text-white">
                            Average Profit Margin
                        </p>

                        {/* Razmak između "Average Profit Margin" i procenta */}
                        <div className="flex items-center space-x-2 mt-3">
                            <p className="text-sm text-green-500">
                                {profitMargin}
                            </p>
                            <ArrowLongUpIcon strokeWidth={2.5} className="w-4 h-4 text-green-500" />
                        </div>
                    </div>

                    <div className="text-right">
                        <div className="inline-flex items-center text-base font-semibold text-gray-900 dark:text-white">
                            {profitMargin}
                        </div>
                    </div>

                    <div className="ml-2">
                        <ArrowLongRightIcon className="h-5 w-5 text-cyan-800 dark:text-cyan-200" />
                    </div>
                </div>
            </Link>
        </li>
    );
}